// extracted by mini-css-extract-plugin
export default {"main_photo_swiper":"HomePage_main_photo_swiper__rf7lE","news_swiper_container":"HomePage_news_swiper_container__-mG8J"};